<template>
  <div class="step-progress-container">
    <ul class="step-progress-bar">
      <li
        v-for="step in stepSize" :key="step"
        :class="{
          active: stepNumber === step,
          finish: stepNumber > step
        }"
        :style="stepWidth"
      ></li>
    </ul>

    <p class="step-title">{{ stepTitle }}</p>

    <hr class="step-row hide-on-large">
  </div>
</template>

<script>
export default {
  name: 'StepProgressBar',
  props: {
    stepTitle: {
      type: String,
      required: true,
    },
    stepNumber: {
      type: Number,
      required: true,
    },
    stepSize: {
      type: Number,
      required: true,
    },
  },
  computed: {
    stepWidth() {
      return { width: `${100 / this.stepSize}%` };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .step-progress-container {
    position: relative;
    width: 100%;
  }

  .step-progress-bar {
    position: relative;
    z-index: 0;

    li {
      list-style-type: none;
      float: left;
      /* width: 25%; */
      position: relative;
      text-align: center;
    }

    li:before {
      content: '';
      width: 18px;
      height: 18px;
      display: block;
      line-height: 18px;
      text-align: center;
      margin: 1px auto 10px auto;
      border: 2px solid $gray-300;
      border-radius: 50%;
      background-color: white;
    }

    li:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: $gray-300;
      top: 9px;
      left: -50%;
      z-index: -1;
    }

    li:first-child:after {
      content: none;
    }

    li.finish:before {
      border: 0px;
      content: url('https://cdn.parcelex.com.br/assets/v3/icons/check-circle-outline.svg');
      border-color: $primary-500;
    }

    li.finish + li:after {
      background-color: $primary-500;
    }

    li.active:before {
      background-color: $primary-500;
      border: 0;
      box-shadow: 0px 0px 0px 4px rgba(54, 163, 202, 0.3);
    }
  }

  .step-title {
    @extend .x-small-semi-bold;
    line-height: 16px;
    color: $primary-500;
    text-transform: uppercase;
    padding-top: 38px;
    text-align: center;
    letter-spacing: 0.12em;
    font-weight: 600;
  }

  .step-row {
    position: absolute;
    bottom: -24px;
    margin-top: 24px;
    margin-bottom: 0;
    height: 1px;
    background-color: $gray-100;
    border: 0;
    left: -24px;
    width: calc(100% + 48px);
  }
</style>
